import request from './request'

/**
 * 监控相关API
 */
export const monitorApi = {
  // 获取Dashboard数据
  getDashboard: () => request.get('/monitor/dashboard'),
  
  // 获取监控指标历史
  getMetrics: (params) => request.get('/monitor/metrics', { params }),
  
  // 获取监控服务状态
  getStatus: () => request.get('/monitor/status'),
  
  // 健康检查
  getHealth: () => request.get('/monitor/health'),
  
  // 获取日志信息
  getLogs: (params) => request.get('/monitor/logs', { params })
}

// 便捷导出
export const getDashboard = monitorApi.getDashboard
export const getMetrics = monitorApi.getMetrics
export const getMonitorStatus = monitorApi.getStatus
export const getHealth = monitorApi.getHealth
export const getLogs = monitorApi.getLogs

export default monitorApi